import React, { useState } from "react";
// import notFound from '../assests/images/404.png'
import notFound from '../assets/images/404.png'
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
export default function NotFound() {

  return (
    <div className="not_found">
      <div className="content_sec">
        <img src={notFound} className="img-fluid notFound_img" />
        <p className="cnt_txt mb-0 mt-3 mt-lg-4">
          The link you followed may be broken, or the page may have been removed. Go back to
          <Link to='/' className="ms-1">homepage <FaArrowRight className='ms-0' size={14} /></Link>
        </p>
      </div>
    </div>
  );
}
